import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/Button';
export function Welcome() {
  const navigate = useNavigate();
  return <div className="w-full h-full bg-black flex flex-col relative overflow-hidden" data-id="element-785">
      {/* Hero Illustration Area */}
      <div className="flex-1 relative flex items-center justify-center pt-10" data-id="element-786">
        {/* Abstract shapes */}
        <motion.div initial={{
        scale: 0,
        rotate: -45
      }} animate={{
        scale: 1,
        rotate: 0
      }} transition={{
        duration: 0.7,
        type: 'spring'
      }} className="absolute w-64 h-64 bg-primary rounded-[40px] rotate-12 opacity-90" data-id="element-787" />
        <motion.div initial={{
        scale: 0,
        x: 50
      }} animate={{
        scale: 1,
        x: 0
      }} transition={{
        duration: 0.7,
        delay: 0.1,
        type: 'spring'
      }} className="absolute w-48 h-48 bg-neonOrange rounded-full -right-10 top-20 opacity-80 mix-blend-screen" data-id="element-788" />

        {/* Emoji Composition */}
        <div className="relative z-10 flex flex-col items-center" data-id="element-789">
          <motion.div animate={{
          y: [0, -15, 0]
        }} transition={{
          repeat: Infinity,
          duration: 3,
          ease: 'easeInOut'
        }} className="text-8xl drop-shadow-2xl" data-id="element-790">
            🤣
          </motion.div>
          <div className="flex gap-4 mt-4" data-id="element-791">
            <motion.div animate={{
            y: [0, 10, 0],
            rotate: [-10, 10, -10]
          }} transition={{
            repeat: Infinity,
            duration: 2.5,
            ease: 'easeInOut'
          }} className="text-5xl drop-shadow-xl" data-id="element-792">
              🔥
            </motion.div>
            <motion.div animate={{
            y: [0, -10, 0],
            rotate: [10, -10, 10]
          }} transition={{
            repeat: Infinity,
            duration: 2.8,
            ease: 'easeInOut'
          }} className="text-5xl drop-shadow-xl" data-id="element-793">
              💯
            </motion.div>
          </div>
        </div>
      </div>

      {/* Content & Actions */}
      <div className="bg-surface rounded-t-[40px] px-6 pt-10 pb-12 flex flex-col items-center z-20 shadow-[0_-10px_40px_rgba(0,0,0,0.5)]" data-id="element-794">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="text-center mb-8" data-id="element-795">
          <h1 className="text-3xl font-poppins font-bold text-white mb-3" data-id="element-796">
            Watch & Share
            <br data-id="element-797" />
            Funny Videos
          </h1>
          <p className="text-softGray text-sm px-4" data-id="element-798">
            Join the biggest comedy club on the internet. Endless laughs await.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="w-full flex flex-col gap-3" data-id="element-799">
          <Button fullWidth onClick={() => navigate('/auth/role')} data-id="element-800">
            Sign Up
          </Button>
          <Button variant="outline" fullWidth onClick={() => navigate('/auth/login')} data-id="element-801">
            Login
          </Button>
          <Button variant="ghost" fullWidth onClick={() => navigate('/feed')} className="text-softGray mt-2" data-id="element-802">
            Continue as Guest
          </Button>
        </motion.div>
      </div>
    </div>;
}